import React, { useEffect, useState } from "react";
import TopBar from "@/components/TopBar";
import ConfettiBurst from "@/components/ConfettiBurst";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Star, Crown, IceCream, Trophy, Rainbow, Bot } from "lucide-react";
import { motion } from "framer-motion";
import { toast } from "sonner";

const iconMap = { star: Star, crown: Crown, "ice-cream": IceCream, trophy: Trophy, rainbow: Rainbow, robot: Bot };

export default function Rewards() {
  const { user, refresh } = useAuth();
  const [rewards, setRewards] = useState([]);
  const [confetti, setConfetti] = useState(0);

  const load = () => api.get("/rewards").then(r => setRewards(r.data));
  useEffect(() => { load(); }, []);

  const redeem = async (rid) => {
    try {
      await api.post("/rewards/redeem", { reward_id: rid });
      await refresh();
      setConfetti(x=>x+1);
      toast.success("Redeemed!");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not redeem");
    }
  };

  return (
    <div className="min-h-screen bg-childhub">
      <TopBar variant="child"/>
      <ConfettiBurst trigger={confetti}/>
      <main className="max-w-5xl mx-auto p-6 sm:p-10">
        <div className="child-card p-6 mb-6 text-center">
          <img src="https://static.prod-images.emergentagent.com/jobs/b25cc76c-c7dd-47c3-a0fd-f45ad7afe07b/images/710107ce696ede2f7bd7d55cb613320ae82fd1a63e92ee0f2fddd8501a997fd8.png"
            alt="reward" className="w-24 h-24 mx-auto animate-float"/>
          <h1 className="font-display text-4xl font-bold text-slate-800">Rewards Shop</h1>
          <p className="text-slate-600">You have <span className="text-amber-600 font-bold">{user?.xp} XP</span></p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {rewards.map((r, i) => {
            const Icon = iconMap[r.icon] || Star;
            const canBuy = (user?.xp || 0) >= r.cost;
            return (
              <motion.div key={r.id} initial={{opacity:0,scale:.9}} animate={{opacity:1,scale:1}} transition={{delay:i*0.04}}
                className="child-card p-5 flex flex-col items-center text-center" data-testid={`reward-${r.icon}`}>
                <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mb-2">
                  <Icon className="w-8 h-8 text-amber-600"/>
                </div>
                <h3 className="font-display font-bold text-slate-800">{r.title}</h3>
                <p className="text-amber-600 font-bold text-sm mb-3">{r.cost} XP</p>
                <button disabled={!canBuy} onClick={()=>redeem(r.id)}
                  data-testid={`redeem-${r.icon}`}
                  className={`text-sm rounded-full px-4 py-2 font-bold ${canBuy?"btn-child":"bg-slate-200 text-slate-500 cursor-not-allowed"}`}>
                  {canBuy ? "Redeem" : "Locked"}
                </button>
              </motion.div>
            );
          })}
        </div>
      </main>
    </div>
  );
}
